import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
    Card,
    CardBody
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

export default function TicketThread({
    saveIntegration,
    channelDetails
}) {
    const [channelData, setChannelData] = useState({
        isTicketCopy: false,
        replyEmail: ""
    })
    useEffect(() => {
        if (channelDetails !== null) {
            setChannelData({
                ...channelData,
                isTicketCopy: channelDetails.isTicketCopy,
                replyEmail: channelDetails.replyEmail
            })
        }
    }, [channelDetails]);
    const handleCopy = (e) => {
        var details = { ...channelDetails };
        details.isTicketCopy = e;
        setChannelData({ ...channelData, isTicketCopy: e });
        saveIntegration({ channelDetails: details });
    };
    const handleSave = () => {
        var details = { ...channelDetails };
        details.replyEmail = channelData.replyEmail;
        saveIntegration({ channelDetails: details });
    };
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center mb-2">
                    <h6>Ticket Responses</h6>
                    <span>View tickets and the corresponding email thread in Unified Inbox</span>
                </div>
                <Separator className="mb-3" />
                <Card className="m-4 p-4">
                    <p className=''>Enable this feature to copy your unique ticketing email address in every ticket response. This will help you see the complete conversation thread in your Unified Inbox.</p>
                    <div className="d-flex w-100 my-2 align-items-center">
                        <h6 className="m-0">Enable Ticket Copy</h6>
                        {/* <Switch
                                className="custom-switch custom-switch-primary custom-switch-small ml-2"
                                checked={channelData.isTicketCopy}
                                name='enabled'
                                onChange={(e) => handleCopy(e)}
                            /> */}
                        <Switch
                            className="agentswitch custom-switch-primary custom-switch-small ml-2 d-sm-inline-block"
                            checked={channelData.isTicketCopy}
                            name='enabled'
                            onChange={(e) => handleCopy(e)}
                        />
                    </div>
                    <p className=''>Your unique email address is below. You do not need to do any thing, we will send a response to this email every time you respond to a ticket generated through Myma.ai.</p>
                    <div className='row mt-2 d-flex align-items-center'>
                        <Colxx md={10} className='pr-0'>
                            <Input
                                type="text"
                                value={channelData.replyEmail}
                                name="text"
                                onChange={(e) => setChannelData({ ...channelData, replyEmail: e.target.value })}
                            />
                        </Colxx>
                        <Colxx md={2} className='px-0'>
                            <CopyToClipboard
                                text={channelData.replyEmail}
                            >
                                <Button
                                    size="xs"
                                    outline
                                    className="ml-3">
                                    <FontAwesomeIcon icon={faCopy} className="fa" /> Copy
                                </Button>
                            </CopyToClipboard>
                        </Colxx>
                    </div>
                </Card>
                <Separator className="my-3" />
                <div className="text-center">
                    <Button
                        size="xs"
                        color="primary"
                        className="my-2"
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>
    )
}  